/** @prettier */

/**
 * グループ編集ダイアログ
 */

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import {ChkInputTextbox} from '../../component/ChkInputTextbox';
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {
  patchCompositionsGroups,
  getCompositionsGroups,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {sortByUnicode} from '../../functions/sort';
import {format} from '../../define';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';

const GroupEditDialog = (props: {
  groupID: string;
  displayGroupInfo: apiIF.resParameters.groupInformations;
  setGroupInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsGroups | null>
  >;
  isOpenDialog: boolean;
  setIsOpenDialog: (arg0: boolean) => void;
}) => {
  //パスパラメータ取得
  const {siteID} = useParams();

  //編集前の室外機情報を取得
  const tempGroupname =
    props.displayGroupInfo['group-name'] === undefined
      ? ''
      : props.displayGroupInfo['group-name'];

  const [groupName, setGroupName] = useState(tempGroupname); //グループの名前
  const [okBtnDisabled, setOKBtnDisabled] = useState(false); //OKボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  //TextBoxのエラー状態
  const [groupNameError, setGroupNameError] = useState(false); //グループの名前

  const trans = useTranslation().t; //翻訳関数

  //入力項目のチェック
  useEffect(() => {
    if (groupName === '' || groupNameError || apiWait) {
      setOKBtnDisabled(true);
    } else {
      setOKBtnDisabled(false);
    }
  }, [groupName, groupNameError, apiWait]);

  /**
   * OKボタン押下時処理
   */
  const editGroup = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) {
      return;
    }

    setOKBtnDisabled(true);
    setAPIWait(true);

    //情報を編集
    const editData: apiIF.reqParameters.patchCompositionsGroups = {
      'group-name': groupName,
    };
    patchCompositionsGroups(siteID, props.groupID, editData)
      .then(() => {
        //情報を取得
        return getCompositionsGroups(siteID, {'max-result': 400});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response['group-informations'].sort(sortByUnicode('group-name'));
        for (const info of response['group-informations']) {
          if (info['unit-informations'] === undefined) continue;
          info['unit-informations'].sort(sortByUnicode('unit-name'));
        }
        props.setGroupInfo(response);
        props.setIsOpenDialog(false);
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setGroupName(tempGroupname);
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('GroupEditDialog.title')}
        </DialogTitle>
        <DialogContent>
          {/* ダイアログに表示するメッセージ */}
          <DialogContentText>{trans('GroupEditDialog.msg')}</DialogContentText>
          {/* 新しいグループ名称の入力欄 */}
          <ChkInputTextbox
            setValue={setGroupName}
            setError={setGroupNameError}
            chkLength={format.BASIC_LENGTH_MAX}
            type="text"
            label={trans('GroupEditDialog.txtField.label.groupName')}
            value={groupName}
            id="mv-inputEditGroupName"
            class="groupSetting__contents__groupNameTextBox"
            helperText=" "
            errHelperText={trans('GroupEditDialog.txtField.errHelperTxt')}
            variant="standard"
            autoFocus={true}
            margin="dense"
            onKeyDown={event => {
              if (event.key === 'Enter' && okBtnDisabled === false) {
                event.preventDefault();
                editGroup();
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          {/* OK/CANCELボタンの設定） */}
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('GroupEditDialog.buttonTxt.cancel')}
            id={'mv-btnCancelEditGp'}
          />
          <PrimaryButton
            onClick={editGroup}
            buttonText={trans('GroupEditDialog.buttonTxt.ok')}
            id="mv-btnOkEditGp"
            disabled={okBtnDisabled}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={`${tempGroupname}EditErrDlgBtn`}
      />
    </>
  );
};
export default GroupEditDialog;
